// src/plugins/metaPixel.js
// Meta Pixel 標準電商事件封裝。
// 基礎碼（fbq init + PageView）已放在 public/index.html。這裡只負責安全地呼叫 window.fbq，
// 統一帶入幣別 TWD，並在追蹤失敗時不影響網站功能。
// Pixel ID: 997949421229963（資料集：S7_G230428_TW_肌黎的像素）

const CURRENCY = 'TWD'

function fire (event, params) {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', event, params)
    }
  } catch (e) {
    console.warn('[MetaPixel] track failed:', event, e)
  }
}

// 同時把購物漏斗事件送一份到自己後台（/admin/traffic 的購物漏斗），失敗不影響網站
function trackFunnel (type, value, extra) {
  try {
    if (typeof navigator === 'undefined') return
    const body = JSON.stringify({ type, value: Number(value) || 0, ...(extra || {}) })
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/track/event', new Blob([body], { type: 'application/json' }))
    } else if (typeof fetch === 'function') {
      fetch('/api/track/event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {})
    }
  } catch (e) { /* ignore */ }
}

// SPA 換頁時的 PageView（基礎碼只會在首次載入時觸發一次）
export function pixelPageView () {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'PageView')
    }
  } catch (e) { /* ignore */ }
}

// 瀏覽商品
export function pixelViewContent ({ id, name, price }) {
  fire('ViewContent', {
    content_ids: [String(id)],
    content_type: 'product',
    content_name: name,
    value: Number(price) || 0,
    currency: CURRENCY
  })
}

// 加入購物車
export function pixelAddToCart ({ id, name, variant, price, quantity }) {
  const qty = Number(quantity) || 1
  fire('AddToCart', {
    content_ids: [String(id)],
    content_type: 'product',
    content_name: name,
    contents: [{ id: String(id), quantity: qty }],
    value: (Number(price) || 0) * qty,
    currency: CURRENCY
  })
  trackFunnel('add_to_cart', (Number(price) || 0) * qty, {
    product_id: id,
    product_name: name,
    variant_name: variant || '',
    quantity: qty
  })
}

// 開始結帳
export function pixelInitiateCheckout ({ items, value }) {
  const contents = (items || []).map(it => ({
    id: String(it.product_id),
    quantity: Number(it.quantity) || 1
  }))
  fire('InitiateCheckout', {
    content_ids: contents.map(c => c.id),
    content_type: 'product',
    contents,
    num_items: contents.reduce((s, c) => s + c.quantity, 0),
    value: Number(value) || 0,
    currency: CURRENCY
  })
  trackFunnel('checkout', Number(value) || 0)
}

// 完成購買（每筆訂單只回報一次，避免重新整理重複計算）
export function pixelPurchase ({ orderId, value }) {
  try {
    const key = 'fb_purchase_' + orderId
    if (orderId && localStorage.getItem(key)) return // 已回報過就跳過
    if (orderId) localStorage.setItem(key, '1')
  } catch (e) { /* localStorage 不可用時仍照常回報 */ }
  fire('Purchase', {
    value: Number(value) || 0,
    currency: CURRENCY,
    content_type: 'product',
    ...(orderId ? { order_id: String(orderId) } : {})
  })
  trackFunnel('purchase', Number(value) || 0)
}
